
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import http from "../../Utils/axiosConfig";


const Logout = () => {
  const navigate = useNavigate();
  const [confirmed, setConfirmed] = useState(false);

  const handleYes = async () => {
    try {
      await http.post("login/logout");
    } catch (err) {
      console.error("Logout error:", err);
    }

    localStorage.clear();
    sessionStorage.clear();

    setConfirmed(true);

    setTimeout(() => {
      navigate("/");
    }, 2000);
  };

  const handleNo = () => {
    navigate("/dashboard"); 
  };

  return (
    <div className="logout-container">
      <div className="logout-box">
        {!confirmed ? (
          <>
            <h2>आपण खरंच Logout करू इच्छिता?</h2>
            <div className="btn-group">
              <button className="yes-btn" onClick={handleYes}>
                होय
              </button>
              <button className="no-btn" onClick={handleNo}>
                नाही
              </button>
            </div>
          </>
        ) : (
          <>
            <h2>आपण यशस्वीरित्या Logout झाले ✅</h2>
            <p>लॉगिन पृष्ठावर नेले जात आहे...</p>
          </>
        )}
      </div>
    </div>
  );
};

export default Logout;
